import Logo from "./Logo";
import { scrollToId } from "@/lib/scrollTo";

const LINKS = [
  { label: "Discover", href: "#discovery" },
  { label: "Experience", href: "#experience" },
  { label: "Versus Legacy", href: "#versus" },
  { label: "Lantix Pro", href: "#pro" },
  { label: "Investors", href: "#investors" },
];

export default function Nav() {
  const go = (e, href) => {
    e.preventDefault();
    scrollToId(href);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50">
      <div className="glass-card border-b border-brand-purple/15">
        <nav className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
          <Logo onClick={(e) => go(e, "#top")} />
          <div className="hidden items-center gap-8 md:flex">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={(e) => go(e, l.href)}
                className="text-sm font-medium text-brand-mist/70 transition-colors duration-300 hover:text-brand-teal"
              >
                {l.label}
              </a>
            ))}
          </div>
          <button
            type="button"
            data-testid="nav-cta-button"
            onClick={(e) => go(e, "#waitlist")}
            className="rounded-full bg-brand-teal px-5 py-2.5 text-sm font-bold text-black shadow-[0_0_24px_rgba(66,246,143,0.35)] transition-all duration-300 hover:shadow-[0_0_40px_rgba(66,246,143,0.6)] hover:brightness-110"
          >
            Get early access
          </button>
        </nav>
      </div>
    </header>
  );
}
